import React from "react"
import { Grid } from "@material-ui/core"
import { InputTextMaster } from "App/Component/ui"
import { messageError } from "utils/all"
import MasterButton from "App/Component/ui/button/MasterButton"
import { convertDateToValidInput, getAge } from "App/utils/helpers"
import Refresh from "App/Assets/icons/Refresh"
import { isNull } from "lodash"
import { dateFormat } from "utils/dates"

function FormDataPasien({ formData, setFormData, handleChange }) {
  return (
    <>
      <p className="fw-600 mt-1 fs-12">DATA PASIEN</p>
      <div>
        <Grid container spacing={1}>
          <Grid item sm={2}>
            <InputTextMaster
              name="patients_id"
              label="ID RM"
              id="patients_id"
              type="number"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="ID RM"
              value={formData.patients_id}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="nama_rm"
              label="NAMA RM"
              id="nama_rm"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Nama RM"
              value={formData.nama_rm}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="gender"
              label="JENIS KELAMIN"
              id="gender"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Jenis Kelamin"
              value={formData.gender}
            />
          </Grid>
          <Grid item sm={4}>
            <div
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <InputTextMaster
                name="umur"
                label="UMUR"
                id="umur"
                placeholder="Umur"
                value={formData.umur}
                onChange={handleChange("umur")}
              />
              <MasterButton
                type={"button"}
                color="warning"
                name=""
                size="sm"
                withIcon={true}
                onClick={() => {
                  !isNull(formData?.date_ob)
                    ? setFormData({
                        ...formData,
                        umur: getAge(dateFormat({ date: formData.date_ob, formatDate: 'YYYY-MM-DD' })),
                      })
                    : setFormData({
                        ...formData,
                        umur: getAge(dateFormat({ date: formData.date_ob_external, formatDate: 'YYYY-MM-DD' })),
                      })
                }}
                style={{
                  marginTop: "1.6rem",
                  width: "32px",
                  height: "32px",
                }}
                icon={
                  <Refresh
                    width="16px"
                    height="16px"
                    style={{
                      marginLeft: "-0.56rem",
                      marginBottom: "0.2rem",
                    }}
                  />
                }
              />
            </div>
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="nohp"
              label="NO HP"
              id="nohp"
              placeholder="No HP"
              value={formData.nohp}
              onChange={handleChange("nohp")}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="phone_number"
              label="TELEPON"
              id="phone_number"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Telepon"
              value={formData.phone_number}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="address_now"
              label="ALAMAT SEKARANG"
              id="address_now"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Alamat"
              value={formData.address_now}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="pekerjaan"
              label="PEKERJAAN"
              id="pekerjaan"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Pekerjaan"
              value={formData.pekerjaan}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="penanggung"
              label="PENANGGUNG"
              id="penanggung"
              disabled={true}
              style={{
                fontWeight: "600",
              }}
              placeholder="Penanggung"
              value={formData.penanggung}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="nik"
              label="NIK"
              id="nik"
              // disabled={true}
              onChange={handleChange("nik")}
              style={{
                fontWeight: "600",
              }}
              placeholder="NIK"
              value={formData.nik}
              error={true}
              message={"Jika kosong, silahkan cek profile rekam medis"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default React.memo(FormDataPasien)
